/**
 * This implementation MUST work on server-side and client-side and
 * thereof it cannot use any server-side only libraries!
 */
import type { LogFn } from 'pino';
import type { LoggerFunction } from '@/utils/logger-lib/logger.type';
import { getErrorStack } from '@/utils/logger-lib/error.util';

export const createLoggerFunction = (implLogFn: LogFn): LoggerFunction => {
  return (arg1: unknown, arg2 = undefined) => {
    // This is the place where we can mangel our logging arguments
    // into format which is accepted by the logger implementation.
    if (arg1 instanceof Error) {
      /**
       * This handles signature LoggerFunction.(error: unknown): void;
       */
      implLogFn({ message: { text: getErrorStack(arg1) } });
    } else if (typeof arg1 === 'string' && arg2 instanceof Error) {
      /**
       * This handles signature LoggerFunction.(text: string, error: unknown): void;
       */
      implLogFn({ message: { text: `${arg1} ${getErrorStack(arg2)}` } });
    } else if (typeof arg2 === 'object' && typeof arg1 === 'string') {
      /**
       * This handles signature LoggerFunction.(text: string, data: ApplicationLogData): void;
       *
       * Even though function signature prohibits adding 'text' attribute into ApplicationLogData
       * we cannot ensure it at runtime. Thereof we need to ensure that we are not losing
       * logged data and we combine both texts.
       */

      const maybyTextFromApplicationLogData: string | undefined = (arg2 as any)?.text;
      const hasTextInApplicationLogData: boolean =
        !!maybyTextFromApplicationLogData && maybyTextFromApplicationLogData !== '';
      const text = `${arg1}${hasTextInApplicationLogData ? ' ' + String(maybyTextFromApplicationLogData) : ''}`;
      implLogFn({
        message: {
          ...arg2,
          text,
        },
      });
    } else if (typeof arg1 === 'object') {
      /**
       * This handles signature LoggerFunction.(text: string | ApplicationLogData): void;
       * case where argument is object.
       */
      implLogFn({ message: arg1 });
    } else {
      /**
       * This handles signature LoggerFunction.(text: string | ApplicationLogData): void;
       * case where argument is string.
       */
      implLogFn({ message: { text: arg1 } });
    }
  };
};
